import {
  Box,
  unstable_DropdownMenu as DropdownMenu,
  IconButton,
  IconUser,
  Text,
} from '@n26/nxd'
import { useOkta } from './OktaContext'
import { useLocalAuth } from './LocalAuthContext'

export const ProfileMenu = () => {
  const { oktaAuth, oktaUserInfo, isAuthenticated: isOktaAuthenticated } =
    useOkta()
  const { isAuthenticated: isLocalAuthenticated, logout: localLogout } =
    useLocalAuth()

  const handleLogout = () => {
    if (isOktaAuthenticated) {
      /**
       * Skips Okta's hosted logout redirect (`/oauth2/v1/logout`), which
       * requires `postLogoutRedirectUri` to be a registered Sign-out
       * redirect URI in the Okta app config — not set up for local dev.
       * tokenManager.clear() removes the tokens and emits the SDK's
       * internal "removed" event, which is what makes authStateManager
       * (and therefore React's isAuthenticated) update. Clearing
       * localStorage directly bypasses that event and leaves the app
       * stuck showing the authenticated page.
       */
      oktaAuth.n26OktaAuth.tokenManager.clear()
    } else if (isLocalAuthenticated) {
      localLogout()
    }
  }

  return (
    <DropdownMenu>
      <DropdownMenu.Trigger>
        <IconButton
          icon={<IconUser />}
          variant='secondary'
          color='neutral'
          aria-label='Profile menu'
        />
      </DropdownMenu.Trigger>
      <DropdownMenu.Content align='end'>
        <Box padding='12'>
          <Text variant='small' color='neutral'>
            {oktaUserInfo?.name ?? oktaUserInfo?.email ?? 'Local session'}
          </Text>
        </Box>
        <DropdownMenu.Separator />
        <DropdownMenu.Item onClick={handleLogout}>Log out</DropdownMenu.Item>
      </DropdownMenu.Content>
    </DropdownMenu>
  )
}
